import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoSummaryAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {LovValueDataService} from './lovValueData.service';
import {LovValueSummary} from '../../../api/model/lovValueSummary.model';
import {LovValueSummaryConverter} from '../../../api/converter/LovValueSummary.converter';
import {LovValue} from '../../../api/model/LovValue.model';


@Injectable({providedIn: 'root'})
export class LovValueSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    LovValueSummary,
    LovValueSummaryConverter,
    LovValue> {
    constructor(dataService: LovValueDataService, converter: LovValueSummaryConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): LovValue {
        return new LovValue();
    }
}
